module.exports = __webpack_public_path__ + "img/dc-chademo.ec246ac5.png";